import { ESalesType } from '../../types/offersData';
import { IApplicationState } from '../../types/redux';
import { getSalesLinks } from '../getSalesLinks';

export function getHasBlackFridaySalesLink(state: IApplicationState) {
  const salesLinks = getSalesLinks(state);

  return salesLinks.some(salesLink => salesLink.salesType === ESalesType.BlackFriday);
}
